/**
 * MODULES - custom recaptcha delay
 * @author PLEJ
 */

const recaptchaDelay = (() => {
    const isForm = document.querySelector("form");
    const init = () => {
        setTimeout( () => {
            if(isForm) appendScript();
        },2000);
    };

    const appendScript = () => {
        const script = document.createElement("script");
        script.src = 'https://www.recaptcha.net/recaptcha/api.js?render=6LcipY4jAAAAAMfEyiQCdOnZRcOenAPf5jEG_Fy6';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    };

    return {
        init: init
    };
})();

export {recaptchaDelay};
